import React, { useState } from 'react';
import { Col, Dropdown, Row } from 'react-bootstrap';
import { useLocation } from 'react-router-dom';

import { isCC, isNCAA, isNCAAAllSports, routeToSpecificScope, teamFullName, text_truncate } from '../../../../helpers';
import { FILTER_GLOBAL_KEYS, FILTER_KEYS, GLOBAL_FILTER_TEAMS_EMPTY, LEAGUES } from '../../../../config/constants';
import { ParamWrapper } from '../ParamWrapper';
import { TeamsSelectorParamsType, TeamsSelectorWrappedParamsType } from './types';
import { useFiltersDispatch, useFiltersState, useUserState } from '../../../../store/hooks';
import { GlobalFilterTeamsNflType, GlobalFilterTeamType } from '../../../../store/types';
import { SCOPE } from '../../../../config/constants';

import '../TeamsMultiSelector/styles.scss';

const TeamsSelectorWrapped = ({
                                changeFilterDataWrapped,
                                forceScope,
                                close,
                                show,
                                open,
                                onApply
                              }: TeamsSelectorWrappedParamsType) => {
  
  const { pathname } = useLocation();
  const specificScope = forceScope || routeToSpecificScope(pathname);
  const {
    [FILTER_GLOBAL_KEYS.TEAMS]: teams = GLOBAL_FILTER_TEAMS_EMPTY,
    [FILTER_KEYS.TEAM_ID]: filterData = '',
    [FILTER_KEYS.SIMPLE_LEAGUE]: leagueSelector = { value: { value: '', label: '', type: '' }, name: '' }
  } = useFiltersState(specificScope, FILTER_GLOBAL_KEYS.TEAMS, FILTER_KEYS.TEAM_ID, FILTER_KEYS.SIMPLE_LEAGUE);
  const user = useUserState();
  const [selectedNewTeamId, setSelectedNewTeamId] = useState(filterData);
  const [appliqued, setAppliqued] = useState(false);
  const { changeFilterData } = useFiltersDispatch();
  
  const league = isCC(user) ? (leagueSelector.value && leagueSelector.value.value) :
    (isNCAA(user) || isNCAAAllSports(user) ? 'ncaa' : 'nfl');
  const teamsGroups: GlobalFilterTeamsNflType = teams.nfl ? teams.nfl : {};
  const teamsChecks = [];
  if (league === LEAGUES.NFL) {
    for (const conference in teamsGroups) {
      teamsGroups[conference].forEach(division => {
        teamsChecks.push(
          <Col xs={3} key={division.name} className={'check-02'}>
            <h3>{division.name}</h3>
            {division.teams.map((team, index) => (
              <Col key={team.teamAbbrName + index} className={'check-01 radio'} style={{ textAlign: 'left' }}>
                <input
                  id={`styled-checkbox-region-team-${division.name}-${index}-${team.teamId}`}
                  type="radio"
                  checked={selectedNewTeamId === team.teamId}
                  onChange={() =>{ 
                    setSelectedNewTeamId(team.teamId);
                    if(specificScope === SCOPE.PRACTICES.PAGE || specificScope === SCOPE.PLAYERS.PAGE || specificScope === SCOPE.GAMES.PAGE){
                      close();
                      if (changeFilterDataWrapped) {
                        changeFilterDataWrapped(team.teamId)();
                        if (!(league === LEAGUES.NFL) && (teams.ncaa)) { //
                          changeFilterData([], FILTER_KEYS.POSITIONS)();
                        }
                      }
                      setAppliqued(true);
                      if (onApply) {
                        onApply(team.teamId, filterData);
                      }
                  }}}
                />
                <label
                  htmlFor={`styled-checkbox-region-team-${division.name}-${index}-${team.teamId}`}
                  className={'radio-label' + (selectedNewTeamId === team.teamId ? ' label-bold' : '')}
                >
                  <img alt="gameImg" src={`/assets/images/logos/${team.teamAbbrName}.svg`} height="20" width="20" />
                  {text_truncate(team.teamFullName,20)}
                </label>
              </Col>
            ))}
          </Col>
        );
      });
    }
  } else if (teams.ncaa) {
    teamsChecks.push(<Col xs={12} key={'ncaa-col'} className={'check-02'} style={{ paddingLeft: 0, paddingRight: 0 }}>
      {teams.ncaa.map((team: GlobalFilterTeamType, index: number) => {
        const isSelected = selectedNewTeamId === team.teamId;
        return (
          <Col
            key={team.teamAbbrName + index}
            className={'check-01 radio'}
            style={{ textAlign: 'left', padding: '10px 12px' }}
          >
            <input
              id={`styled-checkbox-region-team-${team.teamAbbrName}-${index}-${team.teamId}`}
              type="radio"
              checked={isSelected}
              onChange={() => {
                setSelectedNewTeamId(team.teamId);
                if(specificScope === SCOPE.PRACTICES.PAGE || specificScope === SCOPE.PLAYERS.PAGE || specificScope === SCOPE.GAMES.PAGE){
                  close();
                  if (changeFilterDataWrapped) {
                    changeFilterDataWrapped(team.teamId)();
                    if (!(league === LEAGUES.NFL) && (teams.ncaa)) { //
                      changeFilterData([], FILTER_KEYS.POSITIONS)();
                    }
                  }
                  setAppliqued(true);
                  if (onApply) {
                    onApply(team.teamId, filterData);
                  }
              }
              }}
            />
            <label
              htmlFor={`styled-checkbox-region-team-${team.teamAbbrName}-${index}-${team.teamId}`}
              className={'radio-label' + (isSelected ? ' label-bold' : '')}
            >
              <img alt="gameImg" src={`/assets/images/logos/${team.teamAbbrName === 'SGE' || team.teamAbbrName === 'SGW'? 'SBN' : team.teamAbbrName }.png`} height="20" width="20" />
              {team.teamFullName}
            </label>
          </Col>
        );
      })}
    </Col>);
  }
  const onClose = () => {
    close();
    setSelectedNewTeamId(filterData);
  };
  const label = teamFullName(teams, filterData);
  return (
    <Dropdown className={'team-selector-dropdown tt-ooi'} show={show} onToggle={show ? onClose : open}>
      <Dropdown.Toggle id="dropdown-basic" className="btn-border" onClick={show ? onClose : open}>
        <label className={`color-s+${appliqued ? ' appliqued' : ''}`}>TEAM</label>
        {label === '' ? 'Select' : label}
      </Dropdown.Toggle>
      <Dropdown.Menu>
        <div
          className="dropdown-team-selector"
          style={league === LEAGUES.NFL ? { height: 'auto' } : { height: 'auto', width: 'auto' }}
        >
          <form><Row>{teamsChecks}</Row></form>
          {specificScope !== SCOPE.PRACTICES.PAGE && specificScope !== SCOPE.PLAYERS.PAGE && specificScope !== SCOPE.GAMES.PAGE ?
          <div className="footer-s">
           <button className="btn-transparet" onClick={onClose}>Cancel</button>
           <button
             className="btn-blue"
             onClick={() => {
               close();
               if (changeFilterDataWrapped) {
                 changeFilterDataWrapped(selectedNewTeamId)();
                 if (!(league === LEAGUES.NFL) && (teams.ncaa)) { //
                   changeFilterData([], FILTER_KEYS.POSITIONS)();
                 }
               }
               setAppliqued(true);
               if (onApply) {
                 onApply(selectedNewTeamId, filterData);
               }
             }}
           >
             Apply
           </button> 
          </div>
          :
          ''
          }
        </div>
      </Dropdown.Menu>
    </Dropdown>
  );
};

const TeamsSelector = (props: TeamsSelectorParamsType) => {
  const user = useUserState();
  return (
    <ParamWrapper
      fromUrlSearchParam={(cad, props) => {
        if (cad) {
          return cad;
        }
        return user.teamId + '';
      }}
      toUrlSearchParam={(selectedItem) => {
        if (selectedItem) {
          return selectedItem;
        }
        return '';
      }}
      Component={TeamsSelectorWrapped}
      props={props}
      filterKey={FILTER_KEYS.TEAM_ID}
    />
  );
};

export default TeamsSelector;
export * from './types';
